<script setup lang="ts">
import { AppText } from '@shared/ui/typography'
import { CardAdmin } from '@shared/ui/cards'

import { useDisciplineReport } from '../model/discipline-report.hook'
import DisciplinePaymentLinkField from './DisciplinePaymentLinkField.vue'
import DisciplineReportField from './DisciplineReportField.vue'

defineOptions({
  name: 'DisciplineReport',
})

const {
  refPadUrl,
  refParentInfo,
  refKidInfo,
  refDemoDetails,
  refGoalsRows,
} = useDisciplineReport()
</script>

<template>
  <div class="discipline-report">
    <div class="discipline-report__column">
      <CardAdmin
        title="Information"
        class-name="discipline-report__body"
      >
        <DisciplinePaymentLinkField
          v-if="refPadUrl"
          label="PAD link:"
          :link="refPadUrl"
          colored
        />
      </CardAdmin>
      <CardAdmin
        title="Parent info"
        class-name="discipline-report__body"
      >
        <div class="discipline-report__list">
          <div
            v-for="item in refParentInfo"
            :key="item.label"
            class="discipline-report__row"
          >
            <AppText
              name="body1"
              color="slate-500"
              class="discipline-report__label"
            >
              {{ item.label }}
            </AppText>
            <AppText
              name="body1"
              color="slate-900"
            >
              {{ item.value }}
            </AppText>
          </div>
        </div>
      </CardAdmin>
      <CardAdmin
        title="Kid’s general info"
        class-name="discipline-report__body"
      >
        <div class="discipline-report__list">
          <div
            v-for="item in refKidInfo"
            :key="item.label"
            class="discipline-report__row"
          >
            <AppText
              name="body1"
              color="slate-500"
              class="discipline-report__label"
            >
              {{ item.label }}
            </AppText>
            <AppText
              name="body1"
              color="slate-900"
            >
              {{ item.value }}
            </AppText>
          </div>
        </div>
      </CardAdmin>
    </div>
    <div class="discipline-report__column">
      <CardAdmin
        title="Demo lesson details"
        class-name="discipline-report__body"
      >
        <div class="discipline-report__details">
          <div class="discipline-report__details-column">
            <div
              v-if="refDemoDetails.main.length"
              class="discipline-report__metrics"
            >
              <div
                v-for="item in refDemoDetails.main"
                :key="item.label"
                class="discipline-report__metric"
              >
                <AppText
                  name="body1"
                  color="slate-500"
                  class="discipline-report__metric-title"
                >
                  {{ item.label }}
                </AppText>
                <AppText
                  name="body1"
                  color="slate-900"
                >
                  {{ item.value }}
                </AppText>
              </div>
            </div>
            <DisciplineReportField
              v-for="item in refDemoDetails.general"
              :key="item.label"
              :title="item.label"
              :text="item.value"
              boxed
            />
          </div>
          <div class="discipline-report__details-column">
            <DisciplineReportField
              v-for="item in refDemoDetails.common"
              :key="item.label"
              :title="item.label"
              :text="item.value"
              boxed
            />
          </div>
        </div>
      </CardAdmin>
    </div>
    <CardAdmin
      v-if="refGoalsRows.length"
      title="Goals &amp; preferences"
      class="discipline-report__goals"
      class-name="discipline-report__body"
    >
      <div class="discipline-report__goals-grid">
        <DisciplineReportField
          v-for="row in refGoalsRows"
          :key="row.id"
          :title="row.title"
          :text="row.value"
          :link-url="row.linkUrl"
          boxed
        />
      </div>
    </CardAdmin>
  </div>
</template>

<style scoped lang="scss" src="./DisciplineReport.scss" />
